import {Component, inject, OnDestroy} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import * as moment from "moment";
import {BaseService} from "../../../services/base.service";
import {BuCalculationsDetailed, BuCalculationItem} from "../../../interfaces/bu-accounts";

@Component({
  selector: 'app-modal-bu-calculations',
  templateUrl: './modal-bu-calculations.component.html',
  styleUrls: ['./modal-bu-calculations.component.scss']
})
export class ModalBuCalculationsComponent extends BaseService implements OnDestroy {
  private http: HttpClient = inject(HttpClient);

  public isDestroyed: Subject<boolean> = new Subject<boolean>();
  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;
  public balance: number = 0;
  public data: BuCalculationItem[] = [];

  openModal() {
    this.isModalShow = true;
    this.isDarkBackground = true;

    this.http.get<BuCalculationsDetailed>(this.apiRoot + 'bu_accounts/calculations', {
      params: {detailed: '1'}
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(data => {
        if (data.success) {
          this.balance = data.balance;
          this.data = data.data || [];
          this.data.forEach(item => {
            item.datetime = moment(item.datetime).format('DD.MM.YYYY');
          });
        }
      });
  }

  closeModal() {
    this.isModalShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
